<template>
  <custom-callout
    :has-toggle="false"
    class="mb-3"
    :border-color="item.statusColor"
  >
    <div class="row m-0 d-flex align-items-center">
      <div class="col-md-1 col-12 pl-md-0">
        <div class="border-right py-3">
          <custom-balloon
            dot
            class="mt-2"
            :background-color="item.statusColor"
            :text="item.statusName"
          />
        </div>
      </div>
      <div class="col-md-3 col-12 col-spacing mb-3 mb-lg-0">
        <div class="color-secondary-6 font-14 font-weight-normal mr-2">
          Título del Libro:
        </div>
        <div class="color-black font-16 font-weight-normal text-break">
          {{ item.name | empty }}
        </div>
      </div>
      <div class="col-md-3 col-12 col-spacing mb-3 mb-lg-0">
        <div class="color-secondary-6 font-14 font-weight-normal mr-2">
          Materia:
        </div>
        <div class="color-black font-16 font-weight-normal text-break">
          {{ item.subject.name | empty }}
        </div>
      </div>
      <div class="col-md-3 col-12 col-spacing mb-3 mb-lg-0">
        <div class="color-secondary-6 font-14 font-weight-normal mr-2">
          Última Fecha de Inventario:
        </div>
        <div class="color-black font-16 font-weight-normal text-break">
          {{ item.lastDate | date }}
        </div>
      </div>
      <div class="col">
        <drop-down
          :items="actionItems"
          always-show-dropdown
          class="float-md-right mr-5"
        />
      </div>
    </div>
  </custom-callout>
</template>

<script>
import CustomCallout from "custom-callout";
import DropDown from "dropdown";
import CustomBalloon from "custom-balloon";

export default {
  name: "ResultRow",
  components: {
    CustomCallout,
    DropDown,
    CustomBalloon
  },
  props: {
    item: {
      type: Object,
      required: true,
      default: () => ({})
    }
  },
  computed: {
    actionItems() {
      return [
        {
          name: "Administrar Inventario",
          icon: "fas fa-list text-success",
          click: () => this.goToManagement()
        }
      ];
    }
  },
  methods: {
    goToManagement() {
      this.$router.push({
        name: "inventory-catalog-books-management",
        params: {
          id: this.item.id
        }
      });
    }
  }
};
</script>
<style scoped lang="scss">
::v-deep .balloon-container.success {
  background-color: #a3e5b3;
}
::v-deep .balloon-container.warning {
  background-color: #f8b539;
}
</style>
